<template>
  <v-container py-0 ma-0 fluid>
    <v-card flat v-if="increment">
      <increment
        :key="incrementRenderKey"
        :increment="increment"
        :templateItems="items"
        :destination="destinationId"
        :department="department"
        :template-id="itineraryId"
        :agent-id="itiAgentId"
        @update="onUpdateIncrement"
        @updateItinerary="onUpdateItinerary"
        @createItinerary="onCreateItinerary"
        for-itinerary
        :suppliers-comps="suppliersCompsBySupplier"
        @delete="onDeleteIncrement"
        show-create-new-iti
      ></increment>
    </v-card>

    <add-increment-dialog
      v-model="newIncrement"
      :show="showAddIncrement"
      :departures="[]"
      @close="showAddIncrement = false"
      @add="onAddIncrement"
      :templateItems="items"
      hide-dates
      :date="date"
    ></add-increment-dialog>
    <pax-update-dialog
      :show="showPaxUpdater"
      @close="showPaxUpdater = false"
      @update="onPaxUpdate"
      :items="itineraryItems"
    ></pax-update-dialog>
    <v-row v-if="!increment">
      <add-btn
        label="Add Increment"
        icon="mdi-ballot"
        @click="onAddNewIncrement"
      ></add-btn>
    </v-row>
    <div v-if="debug">
      items:
      <code>{{ itineraryInput }}</code>
    </div>
  </v-container>
</template>

<script>
import Increment from "../templates/builder/increments/IncrementCombined";
import AddIncrementDialog from "../templates/builder/increments/AddIncrementDialog";
import AddBtn from "../shared/AddBtn";
import gql from "graphql-tag";
import {
  getTotal,
  groupByFn,
  groupByProp,
  removeGQLTypename,
} from "../../../helpers";
const randomize = require("randomatic");
const DELETE_MUTATION = gql`
  mutation deleteItineraryIncrement($id: ID!) {
    deleteItineraryIncrement(id: $id) {
      id
    }
  }
`;
const CREATE_INCREMENT = gql`
  mutation createItineraryIncrement($input: ItineraryIncrementInput!) {
    createItineraryIncrement(input: $input) {
      id
      date
      step
      minPax
      maxPax
      adjustments {
        edges {
          node {
            id
            paxFrom
            paxTo
            adjustment1
            adjustment2
            adjustment3
            adjustment4
            adjustment100
            foc1
            foc2
            foc3
            foc4
            foc100

            childAdjustment1
            childAdjustment2
            childAdjustment3
            childAdjustment4
            childAdjustment100
            childFoc1
            childFoc2
            childFoc3
            childFoc4
            childFoc100

            infantAdjustment1
            infantAdjustment2
            infantAdjustment3
            infantAdjustment4
            infantAdjustment100
            infantFoc1
            infantFoc2
            infantFoc3
            infantFoc4
            infantFoc100
          }
        }
      }
    }
  }
`;
const INCREMENTS = gql`
  query itineraryIncrements($id: ID) {
    itineraryIncrements(id: $id) {
      edges {
        node {
          id
          date
          step
          minPax
          maxPax
          adjustments {
            edges {
              node {
                id
                paxFrom
                paxTo
                adjustment1
                adjustment2
                adjustment3
                adjustment4
                adjustment100
                foc1
                foc2
                foc3
                foc4
                foc100
                childAdjustment1
                childAdjustment2
                childAdjustment3
                childAdjustment4
                childAdjustment100
                childFoc1
                childFoc2
                childFoc3
                childFoc4
                childFoc100

                infantAdjustment1
                infantAdjustment2
                infantAdjustment3
                infantAdjustment4
                infantAdjustment100
                infantFoc1
                infantFoc2
                infantFoc3
                infantFoc4
                infantFoc100
              }
            }
          }
        }
      }
    }
  }
`;
const UPDATE_INCREMENT = gql`
  mutation updateItineraryIncrement($input: ItineraryIncrementInput!) {
    updateItineraryIncrement(input: $input) {
      id
    }
  }
`;
const SUPPLIERS_COMPS = gql`
  query suppliersComps($ids: [ID]) {
    supplierComps(ids: $ids) {
      edges {
        node {
          serviceId
          supplierId
          paxFrom
          paxTo
          pass
          free
        }
      }
    }
  }
`;
import {
  ITINERARY_RECALCULATE_MUTATION,
  ITINERARY_UPDATE_MUTATION,
  ITINERARY_CREATE_MUTATION,
} from "../../../constants/graphql";
import PaxUpdateDialog from "./builder/tools/PaxUpdateDialog.vue";
export default {
  name: "itinerary-increments",

  props: {
    itinerary: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    Increment,
    AddIncrementDialog,
    AddBtn,
    PaxUpdateDialog,
  },

  data() {
    return {
      debug: false,
      tabs: null,
      showAddIncrement: false,
      date: this.itinerary ? this.itinerary.startDate : null,
      newIncrement: {
        dates: [],
        minPax: 1,
        maxPax: 10,
        step: 2,
      },
      selectedCharges: [],
      showPaxUpdater: false,
      paxSettings: null,
      recalcData: null,
      incrementRenderKey: randomize("Aa0", 32),
      createNewIti: false,
      copyIncrements: false,
    };
  },

  watch: {
    itinerary(newVal) {
      //refresh increment component
      this.incrementRenderKey = randomize("Aa0", 32);
    },
  },

  computed: {
    suppliersCompsBySupplier() {
      return this.itinerary && this.itinerary.comps.edges
        ? groupByProp(
            this.itinerary.comps.edges.map(removeGQLTypename),
            "supplierId"
          )
        : {};
    },
    itinerarySuppliers() {
      return this.itinerary && this.itinerary.items.edges
        ? [
            ...new Set(
              this.itinerary.items.edges.map((item) =>
                item.node.supplier ? item.node.supplier.id : ""
              )
            ),
          ]
        : [];
    },
    headerProps() {
      return this.itinerary && this.itinerary.pax
        ? {
            ...this.itinerary.pax,
          }
        : null;
    },
    increments() {
      return this.itineraryIncrements && this.itineraryIncrements.edges.length
        ? this.itineraryIncrements.edges.map(removeGQLTypename)
        : [];
    },
    increment() {
      return this.increments.length ? this.increments[0] : null;
    },
    itiAgentId() {
      return this.itinerary && this.itinerary.agent
        ? this.itinerary.agent.id
        : null;
    },
    itineraryId() {
      return this.itinerary ? this.itinerary.id : "";
    },
    department() {
      return this.itinerary ? this.itinerary.department : "FIT";
    },
    destinationId() {
      return this.itinerary ? this.itinerary.destination.id : "";
    },
    duration() {
      return 1;
    },
    itineraryItems() {
      const itemsFilter = (item) => {
        return (
          item.serviceTypeName != "MANDATORY_CHARGES" &&
          //item.isIncluded &&
          item.status.toLowerCase().indexOf("cancel") < 0
        );
      };
      return this.itinerary
        ? this.itinerary.items.edges
            .map(removeGQLTypename)
            .filter(itemsFilter)
            .map((item) => ({
              ...item,
              serviceType: item.serviceTypeName,
              stdOccupancy: Number(item.service.stdOccupancy),
            }))
        : [];
    },
    items() {
      const itemsFilter = (item) => {
        return (
          item.node.serviceTypeName != "MANDATORY_CHARGES" &&
          //item.node.isIncluded &&
          item.node.status.toLowerCase().indexOf("cancel") < 0
        );
      };
      return this.itinerary
        ? this.itinerary.items.edges.filter(itemsFilter).map((item) => {
            //console.log(item);

            return {
              id: item.node.id,
              uid: item.node.id,
              orderNo: item.node.orderNo,
              serviceType: item.node.serviceTypeName,
              serviceName: item.node.serviceName,
              supplierName: item.node.supplierName,
              isIncluded: item.node.isIncluded,
              isOptional: item.node.isOptional,
              startDate: item.node.startDate,
              endDate: item.node.endDate,
              stdOccupancy: item.node.service.stdOccupancy,
              maxOccupancy: item.node.service.maxOccupancy,
              serviceId: item.node.service.id,
              supplierId: item.node.supplier.id,

              duration: 1,
              ...item.node.pricing,
              extras: item.node.extras.length > 0 ? item.node.extras : [],
              customPricing: item.node.customPricing,
              remarks: item.node.remarks
                ? {
                    pickupPoint: item.node.remarks.pickupPoint,
                    dropoffPoint: item.node.remarks.dropoffPoint,
                    pickupTime: item.node.remarks.pickupTime,
                    dropoffTime: item.node.dropoffTime,
                    timeFrom: item.node.timeFrom,
                    agentNotes: item.node.timeFrom,
                    supplierNotes: item.node.supplierNotes,
                    voucherNotes: item.node.voucherNotes,
                    flightNo: item.node.flightNo,
                    roomNumbers: item.node.roomNumbers,
                  }
                : undefined,
            };
          })
        : [];
    },
    departures() {
      return [];
    },
    itineraryInput() {
      const basicItems = this.itinerary.items.edges
        .map(removeGQLTypename)
        .filter((item) => item.tags.indexOf("FROM_INCREMENT") < 0)
        //.filter((item) => item.serviceTypeName != "MANDATORY_CHARGES")
        .map(this.fromItiItemToInput);
      return this.itinerary
        ? {
            id: this.itinerary.id,
            startDate: this.itinerary.startDate,
            endDate: this.itinerary.endDate,
            adults: this.paxSettings
              ? this.paxSettings.totals.adults.toString()
              : this.itinerary.pax.adults.toString(),
            children: this.paxSettings
              ? this.paxSettings.totals.children.toString()
              : this.itinerary.pax.children.toString(),
            infants: this.paxSettings
              ? this.paxSettings.totals.infants.toString()
              : this.itinerary.pax.infants.toString(),
            department: this.itinerary.department,
            internalReference: this.itinerary.internalReference,
            internalStatus: this.itinerary.internalStatus,
            destinationId: this.itinerary.destination.id,
            agentId: this.itinerary.agent.id,
            bookedById: this.itinerary.bookedBy.id,
            brand: this.itinerary.brand,
            participants: this.itinerary.participants.edges.map(
              this.mapParticipant
            ),
            items: [
              ...this.applyComps(basicItems),
              //.map(this.setZeroPrices),
              ...this.selectedCharges.map(this.chargeToItiInput),
              ...this.focCharges(),
              ...this.childFocCharges(),
              ...this.infantFocCharges(),
              this.adjustmentCharge(),
            ],
            copyFromId: this.copyIncrements ? this.itinerary.id : null,
          }
        : null;
    },
    suppliersComps() {
      return this.itinerary && this.itinerary.comps
        ? this.itinerary.comps.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onDeleteIncrement(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: INCREMENTS,
              variables: {
                id: this.itineraryId,
              },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Increment Removed.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    applyComps(items) {
      if (this.suppliersComps.length == 0) {
        return items.map(({ supplierId, ...item }) => item);
      }
      const inputItems = [...items];

      const updates = {};
      const suppliersStays = groupByFn(
        inputItems,
        (item) =>
          `${item.supplierId}|${item.startDate
            .toString()
            .substring(0, 10)}|${item.endDate.toString().substring(0, 10)}`
      );
      for (const k of Object.keys(suppliersStays)) {
        const itemsForStay = suppliersStays[k];
        const paxForStay = getTotal(
          itemsForStay,
          (item) => Number(item.adults) + Number(item.children)
        );
        for (const item of itemsForStay) {
          const applicableComps = this.suppliersComps.filter(
            (c) =>
              paxForStay >= c.paxFrom &&
              paxForStay <= c.paxTo &&
              c.supplier.id == item.supplierId &&
              c.service.id == item.serviceId
          );
          if (applicableComps.length > 0) {
            const compToApply = applicableComps[0];
            updates[item.id] = compToApply;
          }
        }
      }
      for (const item of inputItems) {
        if (updates[item.id]) {
          const comp = updates[item.id];
          item.passComp = comp.pass;
          item.supplierComp = comp.free;
        } else {
          item.passComp = 0;
          item.supplierComp = 0;
        }
      }
      //drop supplierId
      return inputItems.map(({ supplierId, ...item }) => item);
    },
    onPaxUpdate(payload) {
      this.showPaxUpdater = false;
      this.paxSettings = { ...payload };
      //return false;
      this.$apollo
        .mutate({
          mutation: ITINERARY_RECALCULATE_MUTATION,
          variables: {
            ...this.itineraryInput,
            items: this.itineraryInput.items.filter(
              (item) => item.serviceType != "MANDATORY_CHARGES"
            ),
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          this.recalcData = { ...data.recalculateItinerary };
          if (this.createNewIti) {
            if (confirm("Do you want to copy increments?")) {
              this.copyIncrements = true;
            } else {
              this.copyIncrements = false;
            }
          }
          this.updateItinerary(this.createNewIti);
        });
    },

    adjustmentCharge() {
      const amount = this.recalcData
        ? this.recalcData.items.edges.reduce((t, item) => {
            t += item.node.totalPrice;
            if (item.node.extras && item.node.extras.length > 0) {
              t += item.node.extras.reduce(
                (te, extra) => (te += Number(extra.totalSell)),
                0
              );
            }
            return t;
          }, 0) * -1
        : Number(this.itinerary.profit.totalSell) * -1;
      return {
        id: randomize("Aa0", 32),
        adults: 1,
        children: 0,
        infants: 0,
        qty: 1,
        startDate: this.itinerary.endDate,
        endDate: this.itinerary.endDate,
        serviceName: "TO ZERO PRICES",
        serviceType: "MANDATORY_CHARGES",
        tags: "FROM_INCREMENT",
        serviceId: "",
        isIncluded: true,
        isOptional: false,
        customPricing: true,
        pricing: {
          adultBuy: 0,
          adultSell: amount,
          childBuy: 0,
          childSell: 0,
          infantBuy: 0,
          infantSell: 0,
          itemBuy: 0,
          itemSell: 0,
          rateTypeCode: "PP",
          currencySell: this.$store.getters.itineraryAgentCurrency,
          currencyBuy: this.$store.getters.itineraryAgentCurrency,
        },
      };
    },
    focCharges() {
      return this.selectedCharges && this.selectedCharges.length
        ? this.selectedCharges
            .filter((c) => Number(c.foc) > 0)
            .map((c) => ({
              ...this.chargeToItiInput(c),
              adults: Number(c.foc),
              children: Number(c.childFoc),
              infants: Number(c.infantFoc),
              serviceName: `FOC: ${c.name} - (${c.paxFrom}-${c.paxTo} Pax)`,
            }))
            .map((c) => ({
              ...c,
              pricing: {
                ...c.pricing,
                adultSell: c.pricing.adultSell * -1,
                childSell: 0,
                infantSell: 0,
              },
            }))
        : [];
    },
    childFocCharges() {
      return this.selectedCharges && this.selectedCharges.length
        ? this.selectedCharges
            .filter((c) => Number(c.childFoc) > 0)
            .map((c) => ({
              ...this.chargeToItiInput(c),
              adults: Number(c.foc),
              children: Number(c.childFoc),
              infants: Number(c.infantFoc),
              serviceName: `FOC: ${c.name} - (${c.paxFrom}-${c.paxTo} Pax)`,
            }))
            .map((c) => ({
              ...c,
              pricing: { ...c.pricing, childSell: c.pricing.childSell * -1 },
            }))
        : [];
    },
    infantFocCharges() {
      return this.selectedCharges && this.selectedCharges.length
        ? this.selectedCharges
            .filter((c) => Number(c.infantFoc) > 0)
            .map((c) => ({
              ...this.chargeToItiInput(c),
              adults: Number(c.foc),
              children: Number(c.childFoc),
              infants: Number(c.infantFoc),
              serviceName: `FOC: ${c.name} - (${c.paxFrom}-${c.paxTo} Pax)`,
            }))
            .map((c) => ({
              ...c,
              pricing: { ...c.pricing, infantSell: c.pricing.infantSell * -1 },
            }))
        : [];
    },
    chargeToItiInput(item) {
      let adults = Number(item.occupancy);
      let children = 0;
      let infants = 0;
      let qty = 1;

      if (this.paxSettings) {
        const { accommodationSettings } = this.paxSettings;

        const accSetting = accommodationSettings.find(
          (s) => s.occupancy == Number(item.occupancy)
        );

        if (accSetting) {
          adults = accSetting.adults;
          children = accSetting.children;
          infants = accSetting.infants;
          if (accSetting.qty != "") {
            qty = accSetting.qty;
          }
        }
      }

      //console.log("charge ->:", item);
      return {
        id: randomize("Aa0", 32),
        adults,
        children,
        infants,
        qty,
        startDate: this.itinerary.endDate,
        endDate: this.itinerary.endDate,
        serviceName: `${item.name} - (${item.paxFrom}-${item.paxTo} Pax)`,
        serviceType: "MANDATORY_CHARGES",
        tags: "FROM_INCREMENT",
        serviceId: "",
        isIncluded: true,
        isOptional: false,
        customPricing: true,

        pricing: {
          adultBuy: 0,
          adultSell: item.total,
          childBuy: 0,
          childSell: item.childTotal,
          infantBuy: 0,
          infantSell: item.infantTotal,
          itemBuy: 0,
          itemSell: 0,
          rateTypeCode: "PP",
          currencySell: this.$store.getters.itineraryAgentCurrency,
          currencyBuy: this.$store.getters.itineraryAgentCurrency,
        },
      };
    },
    setZeroPrices(item) {
      return {
        ...item,
        pricing: {
          adultBuy: item.pricing.adultBuy,
          adultSell: 0,
          childBuy: item.pricing.childBuy,
          childSell: 0,
          infantBuy: item.pricing.infantBuy,
          infantSell: 0,
          itemBuy: item.pricing.itemBuy,
          itemSell: 0,
          rateTypeCode: item.pricing.rateTypeCode,
          currencySell: item.pricing.currencySell,
          currencyBuy: item.pricing.currencyBuy,
        },
      };
    },
    fromItiItemToInput(item) {
      //console.log("item pricing", item.pricing);
      const pricing = item.pricing
        ? {
            currencyBuy: item.pricing.currencyBuy,
            currencySell: item.pricing.currencySell,
            rateTypeCode: item.pricing.rateTypeCode,
            itemBuy: item.pricing.itemBuy,
            itemSell: item.pricing.itemSell,
            adultBuy: item.pricing.adultBuy,
            adultSell: item.pricing.adultSell,
            childBuy: item.pricing.childBuy,
            childSell: item.pricing.childSell,
            infantBuy: item.pricing.infantBuy,
            infantSell: item.pricing.infantSell,
          }
        : {};

      let adults = item.pax.adults;
      let children = item.pax.children;
      let infants = item.pax.infants;
      let qty = item.qty;

      if (this.paxSettings) {
        const { accommodationSettings, otherTypesSettings } = this.paxSettings;
        if (item.serviceTypeName == "ACCOMMODATION") {
          const accSetting = accommodationSettings.find(
            (s) => s.occupancy == item.service.stdOccupancy
          );
          if (accSetting) {
            adults = accSetting.adults;
            children = accSetting.children;
            infants = accSetting.infants;
            if (accSetting.qty != "") {
              qty = accSetting.qty;
            }
          }
        } else {
          const otherTypeSetting = otherTypesSettings.find(
            (s) => s.type == item.serviceTypeName
          );
          if (otherTypeSetting) {
            adults = otherTypeSetting.adults;
            children = otherTypeSetting.children;
            infants = otherTypeSetting.infants;
            const pax = otherTypeSetting.adults + otherTypeSetting.children;
            qty = Math.ceil(pax / item.service.stdOccupancy);
          }
        }
      }
      //console.log(item);
      return {
        id: item.id,
        orderNo: item.orderNo,
        serviceId: item.service ? item.service.id : "",
        supplierId: item.supplier ? item.supplier.id : "",
        serviceName: item.serviceName,
        adults,
        children,
        infants,
        qty,
        startDate: item.startDate,
        endDate: item.endDate,
        serviceType: item.serviceTypeName,
        pricing: item.customPricing ? { ...pricing } : undefined,
        customPricing: item.customPricing,
        isIncluded: item.isIncluded,
        isOptional: item.isOptional,
        ratePlan: item.pricing.ratePlan,
        supplierComp: item.supplierComp,
        passComp: item.passComp,
        extras:
          item.extras && item.extras.length > 0
            ? item.extras.map(this.mapExtra({ adults, children, infants }))
            : undefined,
      };
    },
    mapExtra({ adults, children, infants }) {
      return (node) => {
        let qty = 1;
        if (this.paxSettings) {
          const { extrasSettings } = this.paxSettings;
          const settingForExtra = extrasSettings.find((s) => s.id == node.id);

          if (settingForExtra) {
            qty = settingForExtra.qty;
          }
        }
        if (node.rateBase == "P") {
          if (node.isChildOnly) {
            qty = children;
          } else if (node.isInfantOnly) {
            qty = infants;
          } else {
            qty = adults;
          }
        }
        const pricing = node.customPricing
          ? {
              cost: node.cost,
              sell: node.sell,
              currency: node.currencyBuy,
              currencyExchangeRate: node.currencyBuyExchangeRate,
              currencySellExchangeRate: node.currencySellExchangeRate,
              rateTypeCode: node.rateTypeCode,
            }
          : undefined;

        return {
          id: node.id,
          startDate: node.startDate,
          endDate: node.endDate,
          qty,
          pricing,
        };
      };
    },
    mapParticipant({ node }) {
      return {
        id: node.client ? node.client.id : undefined,
        title: node.title,
        name: node.name,
        surname: node.surname,
        email: node.email,
        mobile: node.mobile,
      };
    },
    onUpdateItinerary(payload) {
      this.selectedCharges = [
        ...payload.charges.map((c) => ({
          ...c,
          paxFrom: payload.paxFrom,
          paxTo: payload.paxTo,
        })),
      ];
      this.createNewIti = payload.createNew;
      this.showPaxUpdater = true;
    },
    onCreateItinerary(payload) {
      this.createNewIti = true;
      this.selectedCharges = [
        ...payload.charges.map((c) => ({
          ...c,
          paxFrom: payload.paxFrom,
          paxTo: payload.paxTo,
        })),
      ];
      this.showPaxUpdater = true;
    },
    onAddNewIncrement() {
      this.showAddIncrement = true;
    },
    onAddIncrement(payload) {
      //console.log("adding itinerary increment", payload);
      const { dates, ...increment } = payload;
      const input = {
        date: dates[0],
        itineraryId: this.itineraryId,
        ...increment,
      };
      this.createIncrement(input);
    },
    updateItinerary(createNew = false) {
      this.$apollo
        .mutate({
          mutation: createNew
            ? ITINERARY_CREATE_MUTATION
            : ITINERARY_UPDATE_MUTATION,
          variables: {
            ...this.itineraryInput,
          },
        })
        .then(({ data }) => {
          if (data.hasOwnProperty("updateItinerary")) {
            this.$router.push("/itinerary/" + this.itinerary.id + "/edit");
            this.$emit("iti-updated");
          } else if (data.hasOwnProperty("createItinerary")) {
            this.createNewIti = false;
            this.$router.push(
              "/itinerary/" + data.createItinerary.id + "/edit"
            );
          }
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    createIncrement(input) {
      this.$apollo
        .mutate({
          mutation: CREATE_INCREMENT,
          variables: {
            input,
          },
          refetchQueries: [
            {
              query: INCREMENTS,
              variables: {
                id: this.itineraryId,
              },
            },
          ],
        })
        .then(({ data }) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Increment Created",
          });
          this.showAddIncrement = false;
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onUpdateIncrement(payload) {
      //console.log("updating", payload);
      this.$apollo
        .mutate({
          mutation: UPDATE_INCREMENT,
          variables: { input: payload },
          refetchQueries: [
            {
              query: INCREMENTS,
              variables: {
                id: this.itineraryId,
              },
            },
          ],
        })
        .then((res) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Increment Updated.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    itineraryIncrements: {
      query: INCREMENTS,
      variables() {
        return { id: this.itineraryId };
      },
      skip() {
        return this.itineraryId == "";
      },
    },
    supplierComps: {
      query: SUPPLIERS_COMPS,
      variables() {
        return { ids: this.itinerarySuppliers };
      },
      skip() {
        return this.itinerarySuppliers.length == 0;
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryIncrements.vue